import React from 'react';
import type { FieldRenderProps } from 'react-final-form';
import TextareaField from './TextareaFieldV2';
import type { TextAreaFieldV2Props } from './TextareaFieldV2';

export interface TextareaFieldV2AdapterProps
  extends FieldRenderProps<string, HTMLElement>,
    TextAreaFieldV2Props {
  /** Fires along with the normal onChange functionality of RFF */
  onChangeCB?: (e: React.ChangeEvent<HTMLElement>) => void;
  /** Text that appears in the bottom-left of the component, opposite of validation */
  onBlurCB?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}

/**
 * ```import TextareaFieldV2Adapter from '@zola/zola-ui/src/components/Form/TextareaFieldV2/TextareaFieldV2Adapter';```
 *
 * Use with `react-final-form`
 */
const TextareaFieldV2Adapter: React.FC<TextareaFieldV2AdapterProps> = ({
  input,
  meta,
  onChangeCB,
  onBlurCB,
  ...rest
}) => {
  const touched = meta?.touched;
  const error = meta?.error;
  const errorMessage = touched && error;

  const inputProps = {
    ...input,
    ...rest,
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      input.onChange(e);
      onChangeCB && onChangeCB(e);
    },
    onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => {
      input.onBlur(e);
      onBlurCB && onBlurCB(e);
    },
    errorMessage,
  };

  return <TextareaField {...inputProps} {...rest} />;
};

export default TextareaFieldV2Adapter;
